import React from 'react';
import { Area, AreaChart, ResponsiveContainer } from 'recharts';

import colors from '@atom/styles/colors';
import { ConversationalAnalyticsChartProps } from '@atom/types/conversationalAnalytics';
import {
  CHART_HEIGHT,
  CHART_MARGINS,
} from '@atom/utilities/conversationalAnalyticsUtilities';

import useConversationalAnalyticsData from './hooks/useConversationalAnalyticsData';
import ConversationalAnalyticsChartAxes from './ConversationalAnalyticsChartAxes';
import ConversationalAnalyticsChartWrapper from './ConversationalAnalyticsChartWrapper';

const ConversationalAnalyticsAreaChart: React.FC<
  ConversationalAnalyticsChartProps
> = ({ spec, width = '100%', height, onExport }) => {
  const { chartData, yField } = useConversationalAnalyticsData(spec);

  return (
    <ConversationalAnalyticsChartWrapper spec={spec} onExport={onExport}>
      <ResponsiveContainer width={width} height={height || CHART_HEIGHT}>
        <AreaChart data={chartData} margin={CHART_MARGINS}>
          <ConversationalAnalyticsChartAxes spec={spec} />
          <Area
            type="monotone"
            dataKey={yField}
            stroke={colors.brand.blue}
            fill={colors.brand.blue}
            fillOpacity={0.3}
          />
        </AreaChart>
      </ResponsiveContainer>
    </ConversationalAnalyticsChartWrapper>
  );
};

export default ConversationalAnalyticsAreaChart;
